import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';
import promoColors from 'theme/promoColors';

import styles from './PromoIcon.module.css';

const defaultThickness = '2';

const SIZE_CLASS_MAP = {
    '16px': styles.size16Px,
    '24px': styles.size24Px,
    '64px': styles.size64Px,
    '80px': styles.size80Px,
};

function renderSVG({ id, color, size, thickness }) {
    const classNames = clsx(styles.svg, SIZE_CLASS_MAP[size]);

    return (
        <svg
            className={classNames}
            style={{
                '--accent': promoColors[color],
                '--thickness': thickness || defaultThickness,
            }}
        >
            <use xlinkHref={`/i/promo-svg-icons/promo-icons.svg#${id}`} />
        </svg>
    );
}

export const PromoIcon = (props) => {
    const containerClass = clsx(styles.container, SIZE_CLASS_MAP[props.size]);

    return (
        <span
            className={containerClass}
            style={{
                marginRight: props.rightIndent || undefined,
                marginLeft: props.leftIndent || undefined,
            }}
        >
            {renderSVG({ id: props.name, color: props.color, size: props.size, thickness: props.thickness })}
        </span>
    );
};

PromoIcon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.oneOf([
        'baseColor',
        'primary',
        'primaryB2B',
        'purple80',
        'purple40',
        'purple20',
        'purple5',
        'gray80',
        'gray40',
        'gray20',
        'gray5',
        'white',
        'error',
        'success',
        'sunflower',
        'cyan',
        'lavender',
        'turquoise',
    ]),
    size: PropTypes.oneOf(['16px', '24px', '64px', '80px']),
    thickness: PropTypes.string, // толщина линии свгшки (stroke)
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
};
